import { addDays, parseISODate, toISODate } from './date';
import { buildWeeksFromRange } from './programProgressRows';

/** `useProgramProgressCells`의 `mondayIsoRange`와 동일 형태 */
export type ProgramProgressMondayIsoRange = { from: string; to: string };

/** 학기 첫·마지막 주 월요일 앞뒤로 버퍼만큼 확장 */
export const PROGRAM_PROGRESS_MONDAY_RANGE_BUFFER_WEEKS = 2;

/**
 * 학기 `starts_on` / `ends_on`으로 주 목록을 만든 뒤, 첫·마지막 월요일 기준으로 버퍼 주를 더한 DB 조회 구간.
 * 주가 없으면 null.
 */
export function buildProgramProgressMondayIsoRangeForTerm(
  startsOn: string,
  endsOn: string,
  bufferWeeks: number = PROGRAM_PROGRESS_MONDAY_RANGE_BUFFER_WEEKS
): ProgramProgressMondayIsoRange | null {
  const weeks = buildWeeksFromRange(startsOn, endsOn);
  if (!weeks.length) return null;
  const firstMonday = weeks[0].mondayIso;
  const lastMonday = weeks[weeks.length - 1].mondayIso;
  const fromDate = addDays(parseISODate(firstMonday), -7 * bufferWeeks);
  const toDate = addDays(parseISODate(lastMonday), 7 * bufferWeeks);
  return { from: toISODate(fromDate), to: toISODate(toDate) };
}

/** 두 구간의 합집합(문자열 비교로 월요일 ISO 정렬 가정) */
export function unionProgramProgressMondayIsoRange(
  a: ProgramProgressMondayIsoRange | null,
  b: ProgramProgressMondayIsoRange | null
): ProgramProgressMondayIsoRange | null {
  if (!a) return b;
  if (!b) return a;
  const from = a.from < b.from ? a.from : b.from;
  const to = a.to > b.to ? a.to : b.to;
  return { from, to };
}
